import React from "react";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import { Pie } from "react-chartjs-2";

// Register chart.js pie components
ChartJS.register(ArcElement, Tooltip, Legend, Title);

export default function QuestionsByTechPie() {
  // Data: Technologies and total question counts
  const data = {
    labels: ["Java", "Python", "JavaScript", "React", "Node.js", "AWS"],
    datasets: [
      {
        label: "Total Questions",
        data: [20, 15, 10, 12, 8, 6], // Example values
        backgroundColor: [
          "rgba(255, 99, 132, 0.6)",
          "rgba(54, 162, 235, 0.6)",
          "rgba(255, 206, 86, 0.6)",
          "rgba(75, 192, 192, 0.6)",
          "rgba(153, 102, 255, 0.6)",
          "rgba(255, 159, 64, 0.6)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "right",
      },
      title: {
        display: true,
        text: "Total Questions by Technology",
      },
    },
  };

  return <div style={{ width: '400px', maxWidth: '100%', display: 'block', margin: '0px auto' }}><Pie data={data} options={options} /></div>;
}
